export default {
  methods: {
    setCaretPosition (e) {
      const oField = e.target;
      const index = oField.value.indexOf(',');
      const iCaretPos = index > -1 ? index > 3 ? index + 1 : index : oField.value.length || 1;

      setTimeout(() => {
        oField.selectionStart = 0;
        oField.selectionEnd = iCaretPos;
      }, 50);
    },
  },
};
